import React from 'react'
import styled from 'styled-components'
import { Button, ButtonThemeType } from './Button'
import { STYLES } from '../../static/style'
import { Text } from '../Text'

const StyledIconButton = styled(Button)``

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
`

const IconContainer = styled.div`
  margin-right: ${STYLES.GUTTER};
  display: flex;
  align-items: center;
`

interface IIconButtonProps {
  className?: string
  icon: React.ReactNode
  children: React.ReactNode
  theme: ButtonThemeType
  inline?: boolean
  onClick?: () => void
  title: string
  label: string
}

const IconButton: React.FC<IIconButtonProps> = ({
  className,
  icon,
  children,
  title,
  theme,
  inline,
  onClick,
  label,
}) => (
  <StyledIconButton
    className={className}
    title={title}
    theme={theme}
    inline={inline}
    onClick={onClick}
    label={label}
  >
    <ButtonContent>
      <IconContainer>{icon}</IconContainer>
      <Text>{children}</Text>
    </ButtonContent>
  </StyledIconButton>
)

export { IconButton }
